(() => {
  if (window.__priceSummaryInit) return;
  window.__priceSummaryInit = true;

  const getFormattedPrice = (cents) => {
    if (!cents || cents === 0) return '$0.00';
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });
  };

  const parsePriceFromElement = (el) => {
    if (!el) return 0;
    const text = el.textContent || '';
    const cleaned = text.replace(/[^0-9.]/g, '');
    const value = parseFloat(cleaned);
    return isNaN(value) ? 0 : Math.round(value * 100);
  };

  const observeSummary = (summary) => {
    const infoContainer = summary.closest('.product__info-container');
    if (!infoContainer) return;

    const productForm = document.querySelector('product-form');
    const sectionId = summary.dataset.sectionId;

    // Observe variant ID input for main product changes
    if (productForm && productForm.form) {
      const idInput = productForm.form.querySelector('input[name="id"]');
      if (idInput) {
        new MutationObserver(() => {
          updateMainProduct(summary);
          updateSubtotal(summary);
        }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    // Observe price block for DOM changes
    const priceWrapper = document.getElementById(`price-${sectionId}`);
    if (priceWrapper) {
      new MutationObserver(() => {
        updateMainProduct(summary);
        updateSubtotal(summary);
      }).observe(priceWrapper, { childList: true, subtree: true, characterData: true });
    }

       // Listen for bundle toggle / variant / upgrade changes
    infoContainer.addEventListener('change', (event) => {
      const target = event.target;
      if (
        target.matches('[data-bundle-variant]') ||
        target.matches('[data-upgrade-checkbox]') ||
        target.matches('[data-upgrade-variant-select]')
      ) {
        updateAll(summary);
      }
    });

    // Bundle toggle click
    infoContainer.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-bundle-toggle]');
      if (toggle) {
        requestAnimationFrame(() => updateAll(summary));
      }
    });
  };

  const updateAll = (summary) => {
    updateMainProduct(summary);
    updateBundle(summary);
    updateUpgrade(summary);
    updateSubtotal(summary);
  };

  const updateMainProduct = (summary) => {
    const mainPriceEl = summary.querySelector('[data-summary-main-price]');
    if (!mainPriceEl) return;

    const sectionId = summary.dataset.sectionId;
    const priceWrapper = document.getElementById(`price-${sectionId}`);
    if (!priceWrapper) return;

    let salePriceCents = 0;
    let comparePriceCents = 0;

    // Check for custom price snippet (price-main-product-custom) via its wrapper
    const customWrapper = priceWrapper.querySelector('[data-main-product-price]');
    if (customWrapper) {
      salePriceCents = parseInt(customWrapper.dataset.priceRaw) || 0;
      const rawCompare = parseInt(customWrapper.dataset.comparePriceRaw) || 0;
      // Only use compare price when it's genuinely higher than sale price
      if (rawCompare > salePriceCents) {
        comparePriceCents = rawCompare;
      }
    } else {
      // Fallback: Dawn default price block selectors
      const saleEl = priceWrapper.querySelector('.price-item--sale .price-item--last, .price__sale .price-item--last, .price-item--regular');
      if (saleEl) salePriceCents = parsePriceFromElement(saleEl);

      const compareEl = priceWrapper.querySelector('.price__sale .price-item--regular, .price-item--sale .price-item--regular');
      if (compareEl) comparePriceCents = parsePriceFromElement(compareEl);
    }

    mainPriceEl.textContent = getFormattedPrice(salePriceCents);

    const mainCompareEl = summary.querySelector('[data-summary-main-compare]');
    if (mainCompareEl) {
      if (comparePriceCents > salePriceCents) {
        mainCompareEl.textContent = getFormattedPrice(comparePriceCents);
        mainCompareEl.style.display = '';
      } else {
        mainCompareEl.style.display = 'none';
      }
    }

    // Update variant title from live variant-selects
    const mainVariantEl = summary.querySelector('[data-summary-main-variant]');
    if (mainVariantEl) {
      const infoContainer = summary.closest('.product__info-container');
      const variantSelects = infoContainer ? infoContainer.querySelector('variant-selects') : null;
      if (variantSelects) {
        const selects = variantSelects.querySelectorAll('select');
        const titles = [];
        selects.forEach((select) => {
          const option = select.options[select.selectedIndex];
          if (option && option.textContent !== 'Default Title') {
            titles.push(option.textContent);
          }
        });
        mainVariantEl.textContent = titles.length ? titles.join(' / ') : '';
      }
    }
  };



  const updateBundle = (summary) => {
    const bundle = document.querySelector('.main-product-bundle-save');
    const isSelected = bundle && bundle.classList.contains('is-selected');

    ['bundle-1', 'bundle-2'].forEach((key) => {
      const row = summary.querySelector(`[data-summary-line="${key}"]`);
      if (!row) return;
      row.hidden = !isSelected;
    });

    if (!bundle || !isSelected) return;

    // 规格文案仍同步；金额不在这里拆算，小计直接取模块折后价
    ['item-1', 'item-2'].forEach((itemKey, idx) => {
      const select = bundle.querySelector(`[data-bundle-variant="${itemKey}"]`);
      const variantEl = summary.querySelector(`[data-summary-bundle-${idx + 1}-variant]`);
      const itemQty = idx === 0 ? 1 : Math.max(1, parseInt(bundle.dataset.item2Quantity, 10) || 1);

      if (!select || !variantEl) return;
      const option = select.options[select.selectedIndex];
      if (!option) return;

      const variantLabel = option.textContent.split('—')[0].trim();
      variantEl.textContent = itemQty > 1 ? `${itemQty} × ${variantLabel}` : variantLabel;
    });
  };

  const updateUpgrade = (summary) => {
    const upgradeItems = document.querySelectorAll('[data-upgrade-item]');
    if (!upgradeItems.length) return;

    upgradeItems.forEach((item, idx) => {
      const num = idx + 1;
      const summaryRow = summary.querySelector(`[data-summary-line="upgrade-${num}"]`);
      if (!summaryRow) return;

      const checkbox = item.querySelector('[data-upgrade-checkbox]');
      if (!checkbox || !checkbox.checked) {
        summaryRow.hidden = true;
        return;
      }

      summaryRow.hidden = false;

      const select = item.querySelector('[data-upgrade-variant-select]');
      if (!select) return;

      const option = select.options[select.selectedIndex];
      if (!option) return;

      const priceEl = summary.querySelector(`[data-summary-upgrade-price="${num}"]`);
      const compareEl = summary.querySelector(`[data-summary-upgrade-compare="${num}"]`);
      const variantEl = summary.querySelector(`[data-summary-upgrade-variant="${num}"]`);

      if (priceEl) {
        const rawPrice = parseInt(option.dataset.priceRaw) || 0;
        priceEl.textContent = getFormattedPrice(rawPrice);
      }

      if (compareEl) {
        const rawCompare = parseInt(option.dataset.comparePriceRaw) || 0;
        const rawPrice = parseInt(option.dataset.priceRaw) || 0;
        if (rawCompare > rawPrice) {
          compareEl.textContent = getFormattedPrice(rawCompare);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (variantEl) {
        variantEl.textContent = option.textContent.replace(/—.*$/, '').trim();
      }
    });
  };

  const updateSubtotal = (summary) => {
    const subtotalOriginal = summary.querySelector('[data-summary-subtotal-original]');
    const subtotalDiscounted = summary.querySelector('[data-summary-subtotal-discounted]');
    if (!subtotalDiscounted) return;

    let totalOriginal = 0;
    let totalDiscounted = 0;

    // Main product
    const mainPrice = summary.querySelector('[data-summary-main-price]');
    const mainCompare = summary.querySelector('[data-summary-main-compare]');
    if (mainPrice) {
      const mainPriceCents = parsePriceFromElement(mainPrice);
      totalDiscounted += mainPriceCents;
      if (mainCompare && mainCompare.style.display !== 'none') {
        totalOriginal += parsePriceFromElement(mainCompare);
      } else {
        totalOriginal += mainPriceCents;
      }
    }

    // Bundle：直接同步模块折后价，不再按单品价格/数量累加
    const bundle = document.querySelector('.main-product-bundle-save');
    if (bundle && bundle.classList.contains('is-selected')) {
      const bundleNewPrice = bundle.querySelector('.main-product-bundle-save__price-new');
      const bundleOldPrice = bundle.querySelector('.main-product-bundle-save__price-old');
      const newCents = parsePriceFromElement(bundleNewPrice);
      totalDiscounted += newCents;

      if (bundleOldPrice && bundleOldPrice.style.display !== 'none') {
        const oldCents = parsePriceFromElement(bundleOldPrice);
        totalOriginal += oldCents > 0 ? oldCents : newCents;
      } else {
        totalOriginal += newCents;
      }
    }

    // Upgrade items
    summary.querySelectorAll('[data-summary-line^="upgrade-"]').forEach((row) => {
      if (row.hidden) return;
      const priceEl = row.querySelector('.price-summary__price--sale');
      const compareEl = row.querySelector('.price-summary__price--original');
      if (priceEl) {
        totalDiscounted += parsePriceFromElement(priceEl);
      }
      if (compareEl && compareEl.style.display !== 'none') {
        totalOriginal += parsePriceFromElement(compareEl);
      } else if (priceEl) {
        totalOriginal += parsePriceFromElement(priceEl);
      }
    });

    subtotalDiscounted.textContent = getFormattedPrice(totalDiscounted);

    if (subtotalOriginal) {
      if (totalOriginal > totalDiscounted) {
        subtotalOriginal.textContent = getFormattedPrice(totalOriginal);
        subtotalOriginal.style.display = '';
      } else {
        subtotalOriginal.style.display = 'none';
      }
    }
  };

  // Init all summaries on page
  const init = () => {
    document.querySelectorAll('[data-price-summary]').forEach((summary) => {
      observeSummary(summary);
      updateAll(summary);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();